<div class="atn-ds-input-field">
  @if (labelSg()) {
    <span class="atn-ds-input-field__label"> {{ labelSg() }} </span>
  }
  <input
    class="atn-ds-input-field__control"
    type="text"
    [value]="valueInner ?? null"
    (change)="onChangeHandler($event)"
    [disabled]="disabledSg()"
    [placeholder]="placeholderSg()"
  />
</div>
